export enum DrawPanels {
  NONE = 'none',
  COLOR = 'color',
}
